(function(){
  function isMobile() { return window.matchMedia('(max-width: 989px)').matches; }

  document.querySelectorAll('[data-rhode-gallery]').forEach(gallery => {
    const track = gallery.querySelector('[data-rhode-track]');
    const slides = gallery.querySelectorAll('.rhode-slide');
    const thumbs = gallery.querySelectorAll('.rhode-thumb');
    const dotsWrap = gallery.querySelector('[data-rhode-dots]');
    const dataEl = gallery.querySelector('[data-rhode-data]');
    const data = dataEl ? JSON.parse(dataEl.textContent.trim() || '[]') : [];

    const eyebrowEl = gallery.querySelector('[data-rhode-eyebrow]');
    const stepEl = gallery.querySelector('[data-rhode-step]');
    const descEl = gallery.querySelector('[data-rhode-desc]');

    const nextDesk = gallery.querySelector('.rhode-arrow.next');
    const prevDesk = gallery.querySelector('.rhode-arrow.prev');
    const nextMob = gallery.querySelector('.rhode-mob-arrow.next');
    const prevMob = gallery.querySelector('.rhode-mob-arrow.prev');

    let index = 0;
    const total = Math.min(slides.length, data.length || slides.length);

    // dots (desktop)
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (let i=0;i<total;i++){
        const d = document.createElement('span');
        if(i===0) d.classList.add('active');
        dotsWrap.appendChild(d);
      }
    }
    const dots = dotsWrap ? dotsWrap.querySelectorAll('span') : [];

    function renderText(){
      const item = data[index] || {};
      if (eyebrowEl) eyebrowEl.textContent = item.eyebrow || 'APPLICATION';
      if (stepEl) stepEl.textContent = item.step || '';
      if (descEl) descEl.textContent = item.desc || '';
    }

    function renderDesktopMedia(){
      if (!track) return;
      track.style.transform = `translateX(-${index * 100}%)`;
    }

    function setActiveUI(){
      thumbs.forEach(t => t.classList.remove('active'));
      if (thumbs[index]) thumbs[index].classList.add('active');

      dots.forEach(d => d.classList.remove('active'));
      if (dots[index]) dots[index].classList.add('active');
    }

    function update(){
      renderText();
      setActiveUI();

      // IMPORTANT:
      // Desktop -> change big image
      // Mobile  -> DO NOT change images (only text)
      if (!isMobile()){
        renderDesktopMedia();
      }
    }

    function next(){
      index = (index + 1) % total;
      update();
    }
    function prev(){
      index = (index - 1 + total) % total;
      update();
    }

    // Desktop arrows change both image+text
    if (nextDesk) nextDesk.addEventListener('click', () => { if (!isMobile()) next(); });
    if (prevDesk) prevDesk.addEventListener('click', () => { if (!isMobile()) prev(); });

    // Mobile arrows only change text (images remain static)
    if (nextMob) nextMob.addEventListener('click', next);
    if (prevMob) prevMob.addEventListener('click', prev);

    // Thumbs:
    // Desktop -> clicking thumbnail changes both image+text
    // Mobile  -> keep images static; thumbnail click does nothing (optional)
    thumbs.forEach((t,i)=>{
      t.addEventListener('click', ()=>{
        if (isMobile()) return;
        index = i;
        update();
      });
    });

    // Keep state on resize
    window.addEventListener('resize', () => {
      // when going to desktop, apply current slide position
      if (!isMobile()) renderDesktopMedia();
    });

    // init
    update();
  });
})();
